export default "__VITE_ASSET__tkTZ8eMe__"